module.exports = __webpack_public_path__ + "img/home-02.137324e7.png";